import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ShiftbookTransferDefinitionDialog {
    constructor(viewModel: any) {
        this.ShiftbookTransferDefinitionId(viewModel.ShiftbookTransferDefinitionId());
        this.TransferAsCopy(viewModel.TransferAsCopy());
        this.AreaId(viewModel.AreaId());
        this.AreaName(viewModel.AreaName());
        this.EquipmentId(viewModel.EquipmentId());
        this.EquipmentName(viewModel.EquipmentName());
        this.ShiftbookId(viewModel.Parent.GetParentId());
        this.Tag(viewModel.Tag());
        if (viewModel.IsNew()) {
            this.TargetShiftbookId(viewModel.Parent.GetParentId());
        }
        else {
            this.TargetShiftbookId(viewModel.TargetShiftbookId());
        }
        this.TransferAsCopy(viewModel.TransferAsCopy() ? viewModel.TransferAsCopy().toString() : "false");
        this.CategoryStructureId.subscribe(() => {
            if (this.CategoryStructureId()) {
                for (var i = 0; i < this.Categories().length; i++) {
                    if (this.Categories()[i].CategoryStructureId === this.CategoryStructureId()) {
                        this.CategoryIdLevel1(this.Categories()[i].CategoryIdLevel1);
                        this.CategoryIdLevel2(this.Categories()[i].CategoryIdLevel2);
                        this.CategoryIdLevel3(this.Categories()[i].CategoryIdLevel3);
                        this.CategoryIdLevel4(this.Categories()[i].CategoryIdLevel4);
                        this.CategoryIdLevel5(this.Categories()[i].CategoryIdLevel5);
                        this.CategoryFullName(this.Categories()[i].CategoryFullName);
                    }
                }
            }
            else {
                this.CategoryIdLevel1(null);
                this.CategoryIdLevel2(null);
                this.CategoryIdLevel3(null);
                this.CategoryIdLevel4(null);
                this.CategoryIdLevel5(null);
                this.CategoryFullName(null);
            }
        });
        this.InfoLevelId.subscribe(() => {
            if (this.InfoLevelId()) {
                for (var i = 0; i < this.Priorities().length; i++) {
                    if (this.Priorities()[i].InfoLevelId === this.InfoLevelId()) {
                        this.InfoLevelText(this.Priorities()[i].InfoLevelText);
                    }
                }
            }
        });
        this.InfoStateId.subscribe(() => {
            if (this.InfoStateId()) {
                for (var i = 0; i < this.Statuses().length; i++) {
                    if (this.Statuses()[i].InfoStateId === this.InfoStateId()) {
                        this.StateText(this.Statuses()[i].StateText);
                    }
                }
            }
        });
        this.Categories.subscribe(() => {
            setTimeout(() => this.CategoryStructureId(viewModel.CategoryStructureId()));
        });
        this.Priorities.subscribe(() => {
            setTimeout(() => this.InfoLevelId(viewModel.InfoLevelId()));
        });
        this.Statuses.subscribe(() => {
            setTimeout(() => this.InfoStateId(viewModel.InfoStateId()));
        });
        this.loadMetadata();
    }
    ShiftbookTransferDefinitionId: KnockoutObservable<string> = ko.observable();
    ShiftbookId: KnockoutObservable<string> = ko.observable();
    TargetShiftbookId: KnockoutObservable<string> = ko.observable();
    TransferAsCopy: KnockoutObservable<string> = ko.observable();
    AreaId: KnockoutObservable<string> = ko.observable();
    AreaName: KnockoutObservable<string> = ko.observable();
    EquipmentId: KnockoutObservable<string> = ko.observable();
    EquipmentName: KnockoutObservable<string> = ko.observable();
    Tag: KnockoutObservable<string> = ko.observable();
    Categories: KnockoutObservableArray<{
        CategoryFullName: string;
        CategoryStructureId: string;
        CategoryIdLevel1: string;
        CategoryIdLevel2: string;
        CategoryIdLevel3: string;
        CategoryIdLevel4: string;
        CategoryIdLevel5: string;
    }> = ko.observableArray([]);
    CategoryStructureId: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel1: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel2: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel3: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel4: KnockoutObservable<string> = ko.observable();
    CategoryIdLevel5: KnockoutObservable<string> = ko.observable();
    CategoryFullName: KnockoutObservable<string> = ko.observable();
    Priorities: KnockoutObservableArray<{
        InfoLevelText: string;
        InfoLevelId: string;
    }> = ko.observableArray();
    InfoLevelId: KnockoutObservable<string> = ko.observable();
    InfoLevelText: KnockoutObservable<string> = ko.observable();
    Statuses: KnockoutObservableArray<{
        StateText: string;
        InfoStateId: string;
    }> = ko.observableArray();
    InfoStateId: KnockoutObservable<string> = ko.observable();
    StateText: KnockoutObservable<string> = ko.observable();
    AreaSearcher: Bindings.baoSearcher = {
        SearchType: "Area",
        ObjectId: this.AreaId,
        ObjectValue: "ShortName",
        AutoComplete: true,
        AutoSearch: true
    };
    EquipmentSearcher: Bindings.baoSearcher = {
        SearchType: "Equipment",
        ObjectId: this.EquipmentId,
        ObjectValue: "EquipmentText",
        AutoComplete: true,
        AutoSearch: true
    };
    loadMetadata = () => {
        return Bao.post("ShiftbookTransferDefinition/GetMetadata")
            .done(result => {
            this.Categories(result.categories);
            this.Priorities(result.priorities);
            this.Statuses(result.statuses);
        });
    };
}
export default ShiftbookTransferDefinitionDialog;